import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-item-operations-role',
  templateUrl: './item-operations-role.component.html',
  styleUrls: ['./item-operations-role.component.scss'],
})
export class ItemOperationsRoleComponent implements OnInit {
  @Input() operation: any = null;
  constructor() {}

  ngOnInit(): void {}
}
